import React, {PropTypes} from 'react';
import {token} from "../../libs/localStorage";
import {FormActions, FormBody, SelectInput, TextInput} from "../Form";
import {observer, inject} from 'mobx-react';
import {observable, action} from 'mobx';
import Form from "../Form";
import {autorun, toJS} from "mobx/lib/mobx";

@inject('userStore', 'roleStore')
@observer
export default class UserProfile extends React.Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  };

  @observable item = {};
  @observable roles = null;

  dispose;
  componentWillMount() {
    const { userStore, roleStore } = this.props;
    const userId = token.getDecoded().id;
    roleStore.fetchItems();
    userStore.fetchItem(userId);
    this.dispose = autorun(() => {
      const foundUser = userStore.findById(userId);
      const foundRoles = roleStore.items.toJS();
      if (foundUser) {
        this.item = {
          ...foundUser.asJson,
          password : ''
        };
      }
      if (foundRoles) { this.roles = foundRoles; }
    });
  }

  componentWillUnmount() { this.dispose(); }

  @action onChangeUsername = e => this.item.username = e.target.value;
  @action onChangeName = e => this.item.name = e.target.value;
  @action onChangeEmail = e => this.item.email = e.target.value;
  @action onChangeMobile = e => this.item.mobile = e.target.value;
  @action onChangePassword = e => this.item.password = e.target.value;

  handleSave = (e) => {
    e.preventDefault();

    const { userStore } = this.props;
    userStore.updateItem(this.item)
      .then(() => {
        this.context.notify.success({message: 'User info updated.'});
      });
  };

  render() {
    return (
      <div>
        <Form>
          <FormBody>
            <TextInput label='Username' value={this.item.username} onChange={this.onChangeUsername}/>
            <TextInput label='Name' value={this.item.name} onChange={this.onChangeName} />
            <TextInput label='Designation' value={this.item.designation} readOnly/>
            <TextInput label='Role' value={this.roles.length && this.item.role_id ? this.roles.find(item => +item.id === +this.item.role_id).name : ''} readOnly/>
            <TextInput type='password' label='Password' value={this.item.password} onChange={this.onChangePassword} />
            <TextInput label='Email' value={this.item.email} onChange={this.onChangeEmail}/>
            <TextInput label='Mobile No.' value={this.item.mobile} onChange={this.onChangeMobile}/>
          </FormBody>
          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/User/UserProfile.js